import Vue from 'vue'
import Vuex from 'vuex'

import UI from './modules/ui.js'
import User from './modules/user.js'
import Common from './modules/common.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    UI,
    User,
    Common
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js